import { FormBuilder } from "./src/sdk.ts";
let formBuilder = new FormBuilder();

document.addEventListener("DOMContentLoaded", async function () {
  await initFormBuilder();
});

async function initFormBuilder() {
  const builder = await formBuilder.initialize();
  // Provide the SDK to the global window object
  window.formBuilder = builder;
  listenForObjectLoaded();
}

function listenForObjectLoaded() {
  window.addEventListener("objectLoaded", async (event) => {
    console.log("objectLoaded");
    await formBuilder.reload();
  });
}
